import { AnimatePresence } from 'framer-motion';
import React from 'react';

import PoorInternetNotification from '../../components/_molecules/PoorInternetNotification';
import GameAPI from '../../frontendServices/gameAPI';
import { useIsOnline } from '../../hooks/useIsOnline';
import { useLatency } from '../../hooks/useLatency';
import useReconnectFailed from '../../hooks/useReconnectFailed';

const PoorInternetStatusProvider = ({
  children,
  gameAPI,
  gameId,
  tenantId,
  uid,
}: {
  children: React.ReactChild;
  gameAPI: GameAPI;
  gameId: string;
  tenantId: string;
  uid: string;
}) => {
  const { hasPoorInternetConnection } = useReconnectFailed(
    gameAPI,
    gameId,
    tenantId,
    uid,
  );

  const { hasPoorLatency } = useLatency();

  const { isOnline } = useIsOnline();

  const shouldShowNotification = hasPoorInternetConnection || hasPoorLatency;

  return (
    <>
      {children}
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
      {/*@ts-ignore */}
      <AnimatePresence>
        {isOnline && shouldShowNotification && (
          <PoorInternetNotification
            type="warning"
            message={
              hasPoorLatency
                ? `Your internet connection seems to be slow`
                : 'You lost connection with the server. Reconnecting...'
            }
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default PoorInternetStatusProvider;
